import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import * as momentTz from 'moment-timezone';

/**
 * @ngdoc filter
 * @name mwDateRange
 * @module mw.components.dateRange
 *
 * @param {DateRange} dateRange - Date Range to format.
 * @param {string} [format] - Formatting rules (see momentjs formatting rules https://momentjs.com/docs/#/displaying/format/). If not specified, 'MMM D' is used.
 * @param {string} [timezone] - Timezone to be used for formatting the date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 * @param {string} [locale] - Locale used for formatting the date range.  If not specified, the browser locale will be used.
 *
 * @returns {string} Formatted date range string.
 *
 * @description
 * `mwDateRange` filter formats a `DateRange` object to a string using the specified `format`.
 *
 */
@Pipe({ name: 'mwDateRange' })
export class DateRangePipe implements PipeTransform {
    private datePipe;

    constructor(
        @Inject('$filter') private $filter: any) {
    }

    transform(
        dateRange: DateRange,
        dateFormat: string = 'MMM D',
        timezone: string = momentTz.tz.guess(),
        theLocale: string = (navigator.language || navigator.userLanguage) ? (navigator.language || navigator.userLanguage).slice(0, 2) : 'en'): String {
        let formattedDateRange = '';

        if (dateRange && dateRange.startDate && dateRange.endDate && theLocale && dateFormat) {
            formattedDateRange = momentTz(dateRange.startDate).tz(timezone).locale(theLocale).format(dateFormat) + ' - ' +  momentTz(dateRange.endDate).tz(timezone).locale(theLocale).format(dateFormat);
        }

        return formattedDateRange;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range.pipe.ts